.footer {
    min-height: 80px;
    padding-top: 20px;
}